/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const BackIconV3 = createIcon({
  displayName: 'BackIconV3',
  viewBox: '0 0 9 16',
  path: (
    <path
      d="M7.50003 14.6004L2.0667 9.16706C1.42503 8.52539 1.42503 7.47539 2.0667 6.83372L7.50003 1.40039"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
